import { useNicheTabModel } from './niche-tab.model'
import type { INicheTab } from './niche-tab.types'
import { NicheTabView } from './niche-tab.view'

export const NicheTab = (props: INicheTab) => {
  const nicheTabModel = useNicheTabModel(props)
  return <NicheTabView territoryId={props.territoryId} territoryName={props.territoryName} {...nicheTabModel} />
}
